import React, { Component } from "react";
import { connect } from "react-redux";
import CommonDynamicFields from "../DynamicFieldComponents/CommonDynamicFields";
import { DocumentTemplateActions } from "../../../../actions";
import { CustomSelect, RevvForm } from "../../../../commonComponents";
import CustomFieldComponentsMap from "./CustomFieldComponentsMap";
import CustomDynamicFieldTopBar from "./CustomDynamicFieldTopBar";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "../DynamicFieldComponents/CustomFieldRulesMap";

// Destructuring
const {
  saveDynamicField,
  toggleDynamicFieldView,
  updateFields,
  setCommonFieldValues,
  nukeDynamicFileData,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class CustomDynamicFieldSelect extends Component {
  constructor(props) {
    super(props);
    this.buttonStatus = true;
    this.state = {
      selectedField: this._prePopulateTypeOfTheFiled(props),
      commonFieldValues: this._prePopulateDataForUpdate(props),
      dynamicFieldsOptions: props.customDynamicFields.filter(
        field => field.name !== "IMAGE" && field.label !== "Image",
      ),
    };
  }

  _prePopulateTypeOfTheFiled = propsData => {
    let returnData = {};
    if (
      propsData.selectedDynamicFieldForUpdate &&
      propsData.selectedDynamicFieldForUpdate.id
    ) {
      for (let v = 0; v < propsData.customDynamicFields.length; v += 1) {
        if (
          propsData.customDynamicFields[v].name ===
          propsData.selectedDynamicFieldForUpdate.type
        ) {
          returnData = propsData.customDynamicFields[v];
          break;
        }
      }
    }
    return returnData;
  };

  _prePopulateDataForUpdate = propsData => {
    let returnData;
    if (
      propsData.selectedDynamicFieldForUpdate &&
      propsData.selectedDynamicFieldForUpdate.id
    ) {
      returnData = {
        field_name: propsData.selectedDynamicFieldForUpdate.label,
        description: propsData.selectedDynamicFieldForUpdate.description,
      };
    } else {
      returnData = JSON.parse(
        JSON.stringify(CustomFieldInitialValuesMap.COMMON),
      );
    }
    return returnData;
  };

  _getDynamicTextFields = value => {
    if (value && value !== "") {
      const FieldMapping = CustomFieldComponentsMap[value];
      if (FieldMapping === undefined) {
        return (
          <React.Fragment>
            <b>Nothing is defined for this field !</b>
          </React.Fragment>
        );
      }
      return (
        <React.Fragment>
          <FieldMapping />
        </React.Fragment>
      );
    }
    return <React.Fragment />;
  };

  _handleDynamicFieldSelection = value => {
    this.props.nukeDynamicFileData();
    this.setState({ selectedField: value });
  };

  render() {
    return (
      <React.Fragment>
        <div className="document-dyn-field-pane">
          <div
            className="document-dynamic-options"
            data-test="customdynamicfieldselect-document-dynamic-options-animated-slideinright">
            <div
              className="clause-options-header"
              data-test="customdynamicfieldselect-customdynamicfield-header">
              <CustomDynamicFieldTopBar />
            </div>
            <div
              className="dynamicfeild-custom-body"
              data-test="customdynamicfieldselect-dynamicfeild-custom-body">
              {this.props.selectedText && (
                <div
                  className="dynamicfieldselect-txt-wrapper"
                  data-test="customdynamicfieldselect-dynamicfieldselect-txt-wrapper">
                  <span
                    className="dynamicfieldselect-txt"
                    data-test="customdynamicfieldselect-dynamicfieldselect-txt">
                    {this.props.selectedText}
                  </span>
                </div>
              )}
              <div
                className="commonfields"
                data-test="customdynamicfieldselect-commonfields-section">
                <RevvForm
                  initialFormValue={this.state.commonFieldValues}
                  customFieldName="COMMON"
                  customFieldComponentRules={CustomFieldComponentRules}
                  customFieldComponentMessages={CustomFieldComponentMessages}
                  validateOnChange
                  render={formProps => {
                    const {
                      handleChange,
                      handleBlur,
                      messages,
                      touched,
                      errors,
                      values,
                      isValid,
                    } = formProps;
                    console.debug("formProps", touched, messages, errors);
                    const commonFormValues = {};
                    if (
                      isValid &&
                      this.state.selectedField.name !== undefined
                    ) {
                      // Here this logic refer for update case(field_name can't be change while update)
                      commonFormValues.field_name =
                        Object.keys(this.props.selectedDynamicFieldForUpdate)
                          .length > 0 &&
                        this.props.selectedDynamicFieldForUpdate.field_name
                          ? this.props.selectedDynamicFieldForUpdate.field_name
                          : values.field_name;
                      commonFormValues.description = values.description;
                      commonFormValues.type = this.state.selectedField.name;
                      commonFormValues.label = values.field_name;
                      commonFormValues.source = "form";
                      this.props.setFlagForCommonFields(true);
                      this.props.setCommonFieldValues(commonFormValues);
                    } else {
                      this.props.setFlagForCommonFields(false);
                      this.props.setCommonFieldValues({});
                    }
                    return (
                      <React.Fragment>
                        <CommonDynamicFields
                          values={values}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          messages={messages}
                        />
                      </React.Fragment>
                    );
                  }}
                />
              </div>
              <div
                className="customselect"
                data-test="customdynamicfieldselect-customselect-section">
                <span
                  className="revvform-label"
                  data-test="customdynamicfieldselect-customfieldtype-label">
                  Custom field type
                  <span
                    className="requiredwitherr-input"
                    data-test="customdynamicfieldselect-fieldtype-required-symbol">
                    {" "}
                    *
                  </span>
                </span>
                <CustomSelect
                  getOptionLabel={({ label }) => label}
                  options={this.state.dynamicFieldsOptions}
                  value={this.state.selectedField}
                  _handleChangeInSelect={this._handleDynamicFieldSelection}
                  isDisabled={
                    this.props.selectedDynamicFieldForUpdate &&
                    this.props.selectedDynamicFieldForUpdate.id
                  }
                />
              </div>
              <div
                className="dynamicfieldcustom-footer-input-wrapper"
                data-test="customdynamicfieldselect-dynamicfieldcustom-footer-input-wrapper">
                {this._getDynamicTextFields(this.state.selectedField.name)}
              </div>
            </div>
          </div>
          <div className="right-pane-bg" />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    editorState,
    fields,
    section,
    selectedText,
    customDynamicFields,
    selectedDynamicFieldForUpdate,
  } = state.TemplateStore.dynamicFields;

  return {
    editorState,
    fields,
    section,
    selectedText,
    customDynamicFields,
    selectedDynamicFieldForUpdate,
  };
};

const mapDispatchToProps = {
  saveDynamicField,
  updateFields,
  toggleDynamicFieldView,
  nukeDynamicFileData,
  setCommonFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomDynamicFieldSelect);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/CustomDynamicFieldSelect/CustomDynamicFieldSelect.js